// The form keeps what the person has typed across navigation (Back, "Edit submission") for as long as the tab is open.
// It is dropped once a ticket has been created, so the next issue starts empty.
const KEY = "eng-triage:form-draft";

export const loadDraft = (): unknown => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as unknown) : undefined;
  } catch {
    return undefined;
  }
};

export const saveDraft = (draft: unknown): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // Storage can be full or blocked. The form still works, it just won't be remembered.
  }
};

export const clearDraft = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
};
